export const useSearchStore = defineStore('search', () => {
  const { $axios } = useNuxtApp()
  const progressbarStore = useProgressbarStore()
  const { showSnackbar } = useSnackbarStore()

  const isNoStyleResultErr = ref(false)
  const isLoadingForDetail = ref(false)
  const isLoadingForGrid = ref(false)
  const product = ref(null)
  const productGridData = shallowRef(null)
  const currentCategoryCode = ref()

  const initSearch = (isKeepGridData = false) => {
    //console.log('>>> initSearch(isKeepGridData)', isKeepGridData)
    isNoStyleResultErr.value = false
    isLoadingForDetail.value = false
    product.value = null
    if (!isKeepGridData) {
      isLoadingForGrid.value = false
      currentCategoryCode.value = null
      productGridData.value = null
    }
  }

  const fetchStyle = async (productNo) => {
    initSearch(true)
    progressbarStore.showLoading()
    isLoadingForDetail.value = true
    try {
      const response = await $axios.get(useApi().catalogApi.CATALOG_STYLE.format(productNo))
      if (response.header.isSuccessful) {
        //console.log('search response data', response.data)
        if (!response.data) showSnackbar(new Error(`The style '${productNo}' could not be found.`))

        product.value = response.data
      }
    } catch (e) {
      showSnackbar(e)
    }
    isLoadingForDetail.value = false
    setTimeout(() => {
      progressbarStore.hideLoading()
    }, 100)
  }
  const fetchStyleListByCategoryWithPaging = async (categoryCode, page = 1, pageSize = 40) => {
    try {
      currentCategoryCode.value = categoryCode
      const pageQuery = `page=${page + 1}`
      const pageSizeQuery = `pageSize=${pageSize}`
      const response = await $axios.get(
        useApi().catalogApi.CATALOG_CATEGORY.format(categoryCode).queryString(pageQuery, pageSizeQuery)
      )
      if (response.header.isSuccessful) {
        return response.data
      }
    } catch (e) {
      console.error('> fetchStyleListByCategoryWithPaging error', e)
      showSnackbar(e)
    }
  }
  const fetchStyleListByCategory = async (categoryCode) => {
    initSearch()
    currentCategoryCode.value = categoryCode
    progressbarStore.showLoading()
    isLoadingForGrid.value = true
    try {
      const response = await $axios.get(useApi().catalogApi.CATALOG_CATEGORY.format(categoryCode))
      if (response.header.isSuccessful) {
        //console.log('search response data', response.data)
        //if (!response.data) showSnackbar(new Error(`The category '${categoryCode}' could not be found.`))
        productGridData.value = response.data
      }
    } catch (e) {
      console.error('> fetchStyleListByCategory error', e)
      showSnackbar(e)
    }
    isLoadingForGrid.value = false
    setTimeout(() => {
      progressbarStore.hideLoading()
    }, 100)
  }
  const fetchStyleListByShowCategory = async (categoryCode) => {
    initSearch()
    currentCategoryCode.value = categoryCode
    progressbarStore.showLoading()
    isLoadingForGrid.value = true
    try {
      const response = await $axios.get(useApi().catalogApi.CATALOG_SHOWCATEGORY.format(categoryCode))
      if (response.header.isSuccessful) {
        //console.log('search response data', response.data)
        //if (!response.data) showSnackbar(new Error(`The category '${categoryCode}' could not be found.`))
        productGridData.value = response.data
      }
    } catch (e) {
      console.error('> fetchStyleListByShowCategory error', e)
      showSnackbar(e)
    }
    isLoadingForGrid.value = false
    setTimeout(() => {
      progressbarStore.hideLoading()
    }, 100)
  }
  return {
    isNoStyleResultErr,
    isLoadingForDetail,
    isLoadingForGrid,
    product,
    productGridData,
    currentCategoryCode,
    initSearch,
    fetchStyle,
    fetchStyleListByCategory,
    fetchStyleListByCategoryWithPaging,
    fetchStyleListByShowCategory
  }
})
